import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { Data2Service } from 'src/app/services/data2.service';
import { HeadService } from 'src/app/services/head.service';
import { PortfolioBallsNavigationComponent } from '../portfolio-balls-navigation/portfolio-balls-navigation.component';
import { SVGSpriteComponent } from 'src/app/pages/_components/svg-sprite/svg-sprite.component';
import { ImplementationsService } from 'src/app/services/implementations.service';
import { ImplementationMixerBoxBComponent } from "../implementation-mixer-box-b/implementation-mixer-box-b.component";
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PortfolioParserService } from 'src/app/services/portfolio-parser.service';


@Component({
  selector: 'app-portfolio-banner-with-nav',
  templateUrl: './portfolio-banner-with-nav.component.html',
  styleUrls: ['./portfolio-banner-with-nav.component.scss'],
  imports: [
    SafePipe,
    CommonModule,
    PortfolioBallsNavigationComponent,
    SVGSpriteComponent,
    FontAwesomeModule,
    RouterModule
]
})
export class PortfolioBannerWithNavComponent implements OnInit, OnDestroy {

  @Input() preRoute:string = "";
  @Input() postRoute:string = "";

  @Input() pre:string = "port";
  @Input() post:string = "cp_ifa"; //S2B2 default
  
  subscriptions: Array<Subscription> = [];
  implementation=false;
  investmentSymbol:any;
  investment:any = {
    displayName:"IFA Index Portfolio",
    description:"Risk Capacity Profile: Most Aggressive: Suitable for investors who have at least 15 years before needing approximately 20% of their investments and are willing to accept a very high degree of volatility in exchange for high portfolio growth potential."
  };
  @Output() secretClick:EventEmitter<any> = new EventEmitter();
  @Output() change:EventEmitter<any> = new EventEmitter<any>();
  preloadLink: HTMLLinkElement|any; 
    showMixDropDown=false;
  showAllocation=false;
  s=1;
  b=1;
    equity:number =50;

  constructor(
    private router:Router, 
    private route:ActivatedRoute, 
    private data2Service:Data2Service, 
    //private head:HeadService, 
    private renderer: Renderer2, 
    @Inject(DOCUMENT) private document: Document,
    public implementationService:ImplementationsService,
    private portfolioParserService:PortfolioParserService,
    private cdr: ChangeDetectorRef
   ) {    

    

    this.subscriptions.push(
      route.paramMap.subscribe((resp:any)=>{
      //console.log("portfolio-banner-with-nav component > route paramMap subscribe > ",resp)

      let mix = resp.get('mix(s\\d+-b\\d+-\\d+)')|| resp.get('mix') || resp.get('id(\\d+)') || resp.get('mixParam');
    //console.log("mix param:",mix)
      portfolioParserService.parsePortfolioMix(mix)
        .subscribe((data)=>{
          //console.log("parsed mix data:",data)
          this.s = data.s;
          this.b = data.b;
          this.equity = data.equity;
          this.investmentSymbol = data.investmentSymbol;
          this.investment = data.investment;
          this.post = data.post;
          this.cdr.detectChanges();
        });
      
    // portfolio-parser.service.ts

    }));
  }
    
  ngOnDestroy(): void {
   this.subscriptions.forEach(x=>x.unsubscribe());
    // Optional: Remove the preload link if it's not needed after this component is destroyed  
    if (this.preloadLink) {  
      this.renderer.removeChild(this.document.head, this.preloadLink);  
    }  
  }

  ngOnInit(): void {
    this.preloadImage();
      this.cdr.detectChanges();  
  }

  pballClick(){
    this.implementation =! this.implementation;
    this.secretClick.emit();
  }
  
  pballClick2(){
    //console.log("pballclick2",`/portfolios/${this.equity}/s${this.s}-b${this.b}-${this.equity}/implementation/mix`)
    //this.router.navigate([`/portfolios/${this.equity}/implementation/mix/s${this.s}-b${this.b}-${this.equity}`],{fragment:`results`});
  }
  portBallNavChange(evt:any){
    console.log("portBallNavChange",evt)
    this.change.emit(evt);
      this.cdr.detectChanges();
  }

  preloadImage(): void {  
    const link: HTMLLinkElement = this.renderer.createElement('link');  
    this.renderer.setAttribute(link, 'rel', 'preload');  
    this.renderer.setAttribute(link, 'fetchpriority', 'high'); 
    this.renderer.setAttribute(link, 'href', '/assets/svg/polygons-blue.svg');  
    this.renderer.setAttribute(link, 'as', 'image');  
    this.renderer.appendChild(this.document.head, link);  
      
    // Keep reference to remove later if needed  
    this.preloadLink = link;  
  }  


  presetClickedB(e:any){
    console.log("presetClickedB",e, `"/portfolios/${this.equity}"`)
    const scrollY = window.scrollY;      
     this.router.navigateByUrl(`/portfolios/${this.equity}`).then(() => {         
        setTimeout(()=>{           
          window.scrollTo({ top: scrollY });  
        },200)       
      });     
    this.showMixDropDown=false;
  }
}
